module.exports = __webpack_public_path__ + "dist/assets/img/motiondesignsystem.fb1fa393.svg";